import React from "react";
import Seo from "@/components/Seo";
import { Container } from "@/components/Section";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <Seo title="Privacy Policy" description="Privacy Policy for Prasad Tutor Group (PTG) website." />
      <Container className="py-16 sm:py-24 max-w-3xl">
        <h1 className="font-heading text-4xl font-extrabold text-slate-900 tracking-tight">Privacy Policy</h1>
        <p className="text-sm text-slate-400 mt-2">Last updated: June 2026</p>
        <div className="prose prose-slate mt-8 space-y-5 text-slate-600 leading-relaxed">
          <p>This Privacy Policy explains how Prasad Tutor Group (PTG) ("PTG", "we", "us") collects and uses information submitted through this website.</p>
          <h2 className="text-xl font-bold text-slate-800">Information We Collect</h2>
          <p>When you submit an admission enquiry, we collect the details you provide such as student name, parent name, mobile number, WhatsApp number, email, current standard, school name, course of interest and any message. We collect this information only to respond to your enquiry.</p>
          <h2 className="text-xl font-bold text-slate-800">How We Use Information</h2>
          <p>We use your information solely to contact you regarding your enquiry and to provide information about our courses and admissions. We do not sell or rent your personal information to third parties.</p>
          <h2 className="text-xl font-bold text-slate-800">Cookies</h2>
          <p>We use minimal cookies to remember your preferences (such as dismissing the cookie notice). No tracking or advertising cookies are used.</p>
          <h2 className="text-xl font-bold text-slate-800">Contact</h2>
          <p>For any privacy-related questions, please contact PTG using the details on our Contact page.</p>
        </div>
      </Container>
    </div>
  );
}
